/**
 * SHIPPING SPEEDS
 */
export const NEXT_WOW = 'next-wow';
export const SECOND = 'second';
export const NEXT_BUSINESS = 'next-business';
export const NEXT = 'next';
export const STD_US_NON_48 = 'std-us-non48';
export const STD_N_US = 'std-n-us';
export const STD_US_MILITARY = 'std-us-military';
export const STD_US_PROTECT = 'std-us-protect';
export const STD_US = 'std-us';

export const FREE_SHIPPING_SPEEDS = [NEXT_WOW, STD_US_NON_48, STD_N_US, STD_US_MILITARY, STD_US_PROTECT, STD_US];

export const HIGHLIGHTED_SHIPPING_OPTION_MAP: {
  base: Record<string, boolean>;
  holiday: Record<string, boolean>;
  prime: Record<string, boolean>;
  vip: Record<string, boolean>;
} = {
  base: {
    [NEXT_WOW]: true,
    [STD_US_NON_48]: true
  },
  holiday: {
    [NEXT]: true,
    [NEXT_BUSINESS]: true,
    [SECOND]: true
  },
  prime: {
    [NEXT]: true,
    [NEXT_BUSINESS]: true,
    [SECOND]: true
  },
  vip: {
    [NEXT]: true,
    [NEXT_BUSINESS]: true
  }
};
